import { render, staticRenderFns } from "./AdministrationUsers.vue?vue&type=template&id=66f95d46&"
import script from "./AdministrationUsers.vue?vue&type=script&lang=js&"
export * from "./AdministrationUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports